// extracted by mini-css-extract-plugin
export default {"only_print":"bible-coloring_only_print__MXA4H","footer_english":"bible-coloring_footer_english__RN+d0","footer_Hebrew":"bible-coloring_footer_Hebrew__Ekyec"};